"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.string.bold.js");

var _react = _interopRequireDefault(require("react"));

var _currency = require("@nerdwallet/currency");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _chicletModule = _interopRequireDefault(require("./chiclet.module.less"));

var colorMap = {
  green: 'positive',
  'neutral-darkest': 'default',
  'neutral-lighter': 'default',
  'neutral-light': 'default',
  red: 'critical'
};

var Chiclet = function Chiclet(_ref) {
  var bold = _ref.bold,
      className = _ref.className,
      color = _ref.color,
      text = _ref.text,
      type = _ref.type;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(className, _chicletModule.default["tab-container"], _chicletModule.default["tab-container__".concat(color)], _chicletModule.default["tab-container__".concat(type)])
  }, /*#__PURE__*/_react.default.createElement(_currency.Text, {
    bold: bold,
    component: "p",
    size: "x-small",
    tone: colorMap[color]
  }, text));
};

Chiclet.defaultProps = {
  bold: true,
  color: 'neutral-lighter',
  text: '',
  type: 'wide'
};
Chiclet.propTypes = {
  bold: _propTypes.default.bool,
  // className will not be able to override base-styles defined in the .less file.
  className: _propTypes.default.string,
  color: _propTypes.default.oneOf(['green', 'neutral-darkest', // deprecated; use neutral-lighter instead
  'neutral-lightest', 'neutral-lighter', 'neutral-light', 'red', 'yellow-lighter']),
  text: _propTypes.default.string,
  type: _propTypes.default.oneOf(['wide', 'tall'])
};
var _default = Chiclet;
exports.default = _default;